export const NRRD_TYPES_TO_TYPEDARRAY = {
  'signed char': Int8Array,
  int8: Int8Array,
  int8_t: Int8Array,
  uchar: Uint8Array,
  'unsigned char': Uint8Array,
  uint8: Uint8Array,
  uint8_t: Uint8Array,
  short: Int16Array,
  'short int': Int16Array,
  'signed short': Int16Array,
  'signed short int': Int16Array,
  int16: Int16Array,
  int16_t: Int16Array,
  ushort: Uint16Array,
  'unsigned short': Uint16Array,
  'unsigned short int': Uint16Array,
  uint16: Uint16Array,
  uint16_t: Uint16Array,
  int: Int32Array,
  'signed int': Int32Array,
  int32: Int32Array,
  int32_t: Int32Array,
  uint: Uint32Array,
  'unsigned int': Uint32Array,
  uint32: Uint32Array,
  uint32_t: Uint32Array,
  float: Float32Array,
  double: Float64Array,
};
